<template>
    <div>
        <div class="add-top">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/site/site' }">场地管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="add-content">
            <div class="content">
                <div class="page-title">{{title}}</div>
                <div class="created-box">
                    <div class="left">
                        <div class="item d_flex " @click="changeStep(0)" :class="currentStep>0?'active':'writting'">
                            <div class="step">1</div>
                            <div>基本信息</div>
                        </div>
                        <div class="item d_flex" @click="changeStep(1)"   :class="currentStep>1?'active':(currentStep==1?'writting':'')">
                            <div class="step">2</div>
                            <div>位置信息</div>
                        </div>
                        <div class="item d_flex" @click="changeStep(2)"  :class="currentStep>2?'active':(currentStep==2?'writting':'')">
                            <div class="step">3</div>
                            <div>场地详情</div>
                        </div>
                        <div class="item d_flex" @click="changeStep(3)"  :class="currentStep>3?'active':(currentStep==3?'writting':'')">
                            <div class="step">4</div>
                            <div>图片信息</div>
                        </div>
                    </div>
                    <div class="right">
                            <div v-show="currentStep==0" >
                                <el-form ref="form1" :model="form1" label-width="120px" align="left" :rules="rules1" >
                                <el-form-item label="场地名称" style="width: 350px;" prop="space_name">
                                    <el-input v-model="form1.space_name" placeholder="请输入场地名称"></el-input>
                                </el-form-item>
                                <el-form-item label="场地类型" prop="cate_id">
                                    <el-cascader :options="spaceList" v-model="form1.cate_id"  :props="{ value: 'cate_id', label: 'name',children:'child'}" @change="selectType" clearable></el-cascader>
                                </el-form-item>
                                <div class="d_flex ">
                                    <el-form-item label="场地面积" style="width: 350px;" prop="area">
                                        <el-input v-model="form1.area" placeholder="1000"></el-input>
                                    </el-form-item>
                                    <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;">m²</div>
                                </div>
                                <div class="d_flex ">
                                    <el-form-item label="场地尺寸" style="width: 550px;">
                                        <div class="d_flex">
                                            <div class="item">
                                                <el-form-item label="长" label-width="50px" prop="size_length">
                                                    <el-input v-model="form1.size_length" placeholder="长"></el-input>
                                                </el-form-item>
                                            </div>
                                            <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;margin-right: 5px">m</div>
                                            <div class="item" style="margin-right: 5px">
                                                <el-form-item label="宽" label-width="50px" prop="size_width">
                                                    <el-input v-model="form1.size_width" placeholder="宽"></el-input>
                                                </el-form-item>
                                            </div>
                                            <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;">m</div>
                                            <div class="item" style="margin-right: 5px">
                                                <el-form-item label="高" label-width="50px">
                                                    <el-input v-model="form1.size_height" placeholder="高"></el-input>
                                                </el-form-item>
                                            </div>
                                            <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;">m</div>
                                        </div>
                                    </el-form-item>

                                </div>
                                <div class="d_flex ">
                                    <el-form-item label="日价格" style="width: 350px;"  prop="price">
                                        <el-input v-model="form1.price" placeholder="请输入刊例平时价格"></el-input>
                                    </el-form-item>
                                    <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;">元/天</div>
                                </div>
                                <div class="d_flex ">
                                    <el-form-item label="周价格" style="width: 350px;"  prop="price">
                                        <el-input v-model="form1.price_s" placeholder="请输入刊例周末价格"></el-input>
                                    </el-form-item>
                                    <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;">元/天</div>
                                </div>
                                <div class="d_flex ">
                                    <el-form-item label="月价格" style="width: 350px;"  prop="price">
                                        <el-input v-model="form1.floor_price" placeholder="请输入平日实际价格"></el-input>
                                    </el-form-item>
                                    <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;">元/天</div>
                                </div>
                                <div class="d_flex ">
                                    <el-form-item label="实际价格" style="width: 350px;"  prop="floor_price">
                                        <el-input v-model="form1.floor_price_s" placeholder="请输入周末实际价格"></el-input>
                                    </el-form-item>
                                    <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;">元/天</div>
                                </div>
                                <div class="d_flex ">
                                    <el-form-item label="起租时间" style="width: 350px;" >
                                        <el-input v-model="form1.lease_commencement_date" placeholder="请输入起租时间"></el-input>
                                    </el-form-item>
                                    <div style="margin-left: 5px;height: 100%;line-height: 40px;color: #f50;font-size: 14px;">天</div>
                                </div>
                                <el-form-item label="能否进车" style="width: 350px;"  >
                                    <el-switch
                                            v-model="form1.use_car"
                                            active-color="#f00"
                                            inactive-color="#999999"
                                            active-text="能"
                                            inactive-text="不能"
                                    >
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="营业时间" prop="date1"  style="width: 450px;">
                                    <div class="d_flex ">
                                        <el-time-select
                                                v-model="form1.date1"
                                                :picker-options="{
                                                    start: '00:30',
                                                    step: '00:15',
                                                    end: '23:30'
                                                  }"
                                                placeholder="选择时间">
                                        </el-time-select>
                                        <div class="line" style="margin: 0 10px">至</div>
                                        <el-time-select
                                                v-model="form1.date2"
                                                :picker-options="{
                                                    start: '00:30',
                                                    step: '00:15',
                                                    end: '23:30'
                                                  }"
                                                placeholder="选择时间">
                                        </el-time-select>
                                    </div>
                                </el-form-item>
                        </el-form>
                            </div>
                            <div v-show="currentStep==1">
                                <el-form ref="form2" :model="form2" label-width="120px" align="left" :rules="rules2" >
                                   <el-form-item label="所属城市"  prop="city_id">
                                       <el-cascader :options="cityArr" v-model="form2.city_id"  :props="{ value: 'city_id', label: 'name',children:'child'}" @change="selectType" filterable clearable></el-cascader>
                                   </el-form-item>
                                   <el-form-item label="详细位置" style="width: 430px;" prop="address">
                                       <el-input v-model="form2.address" placeholder="请输入详细位置"  @input="getAddress"></el-input>
                                   </el-form-item>
                                   <el-form-item label="经纬度" style="width: 830px;"  prop="lng">
                                       <div class="d_flex">
                                           <el-input v-model="form2.lng" placeholder="经度" :disabled="true" style="width: 150px; margin-right: 10px;" ></el-input>
                                           <el-input v-model="form2.lat" placeholder="纬度" :disabled="true" style="width: 150px; margin-right: 10px;"></el-input>
                                           <span class="col_red">点击地图位置点获取经纬度</span>
                                       </div>
                                   </el-form-item>
                                </el-form>
                               <div class="map-box">
                                    <el-input v-model="addressKeyword" placeholder="输入详细地址查找详细位置"></el-input>
                                   <baidu-map class="bmView" id="baidu-map" :scroll-wheel-zoom="true" :center="location" :zoom="zoom" @click="getLocationPoint" ak="AkfcPW05jWhN7BbQkX7kpH6dfMdzLuME">
                                       <bm-view style="width: 100%; height:400px; flex: 1"></bm-view>
                                       <bm-local-search :keyword="addressKeyword" :auto-viewport="true" style="display: none"></bm-local-search>
                                   </baidu-map>
                               </div>

                           </div>
                            <div v-show="currentStep==2">
                                <el-form ref="form3" :model="form3" label-width="120px" align="left" :rules="rules3" >
                                    <el-form-item label="联系人姓名" style="width: 350px;" prop="contact_name">
                                        <el-input v-model="form3.contact_name" placeholder="请输入联系人姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人手机号" style="width: 350px;" prop="contact_phone">
                                        <el-input v-model="form3.contact_phone" maxlength="11" placeholder="请输入联系人手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人微信" style="width: 350px;" prop="contact_wx">
                                        <el-input v-model="form3.contact_wx" placeholder="请输入联系人微信"></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人职务" style="width: 350px;" prop="contact_position">
                                        <el-input v-model="form3.contact_position" placeholder="请输入联系人职务"></el-input>
                                    </el-form-item>
                                    <el-form-item label="场地文字介绍" style="width: 500px;" prop="content">
                                        <el-input type="textarea" v-model="form3.content"  placeholder="请输入场地介绍" autosize></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div v-show="currentStep==3">
                                <el-form ref="rulesForm" :model="rulesForm" label-width="120px" align="left" :rules="rules4" >
                                <div class="d_flex">
                                    <el-form-item  label="场地封面图" style="width: 100%;" prop="fileList">
                                        <div class="d_flex">
                                            <div class="upload-img-box d_flex" v-if="rulesForm.fileList.length>0">
                                                <div class="img" v-for="(item,index) in rulesForm.fileList">
                                                    <img :src="item|handleImg" @click="previewImg(item)" alt="">
                                                    <i class="el-icon-error" @click="deleteImg(1,index)"></i>
                                                </div>
                                            </div>
                                            <el-upload class="avatar-uploader"
                                                       ref="otherLicense"
                                                       :auto-upload="false"
                                                       action
                                                       :on-change="otherSectionFile"
                                                       :multiple="true"
                                                       list-type="picture-card"
                                                       v-if="rulesForm.fileList.length<1"
                                            >
                                                <i class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                        </div>
                                    </el-form-item>
                                </div>
                                <el-form-item  label="场地相册" style="width: 100%;" prop="fileList1">
                                        <el-upload class="avatar-uploader"
                                                   ref="otherLicense"
                                                   action
                                                   :auto-upload="false"
                                                   :file-list="rulesForm.fileList1"
                                                   :on-change="otherSectionFile1"
                                                   :on-preview="handlePicPreview1"
                                                   :on-remove="handleRemove1"
                                                   list-type="picture-card"
                                                   multiple>
                                            <i class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                </el-form-item>
                                <el-form-item  label="场地平面图" style="width: 100%;" prop="fileList2">
                                    <div class="upload-img-box d_flex" v-if="rulesForm.fileList2.length>0">
                                        <div class="img" v-for="(item,index) in rulesForm.fileList2">
                                            <img :src="item|handleImg" @click="previewImg(item)" alt="">
                                            <i class="el-icon-error" @click="deleteImg(2,index)"></i>
                                        </div>
                                    </div>
                                    <el-upload class="avatar-uploader"
                                               ref="otherLicense"
                                               action
                                               :auto-upload="false"
                                               :on-preview="handlePicPreview2"
                                               :on-remove="handleRemove2"
                                               :file-list="rulesForm.fileList2"
                                               :on-change="otherSectionFile2"
                                               list-type="picture-card"
                                               multiple
                                               v-if="rulesForm.fileList2.length<1"
                                    >
                                        <i class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                </el-form>
                            </div>

                    </div>
                </div>
            </div>
            <div class="bottom-box d_flex">
                <el-button @click="backPage">返回</el-button>
                <el-button v-if="currentStep>0" @click="preStep">上一步</el-button>
                <el-button type="primary" @click="nextStep" v-if="currentStep<3">下一步</el-button>
                <el-button type="primary" v-if="currentStep==3" @click="submitForm">提交</el-button>
                <el-button @click="openPreview">在线预览</el-button>
            </div>
        </div>
        <el-dialog
                title="场地详情"
                :visible.sync="infoPop"
                width="375px"
                >
                <div class="preview-box">
                    <div class="img-box" v-if="rulesForm.fileList[0]">
                        <img :src="rulesForm.fileList[0]|handleImg" alt="">
                    </div>
                    <div class="space-msg">
                        <p style="font-size: 16px;color: #000;">场地名称：{{form1.space_name||''}}</p>
                        <p style="display: flex;justify-content: space-between"><span>场地面积：{{form1.area||0}}平方</span><span>尺寸：{{form1.size_length||0}}m*{{form1.size_width||0}}</span></p>
                        <p>场地位置：{{form2.address}}</p>
                        <div class="price d_flex j_b">
                            <p>刊例平时价：&yen;{{form1.price||0}}</p>
                            <p>刊例周末价：&yen;{{form1.floor_price||0}}</p>
                        </div>
                        <div class="price d_flex j_b">
                            <p>实际平时价：&yen;{{form1.price_s||0}}</p>
                            <p>实际周末价：&yen;{{form1.floor_price_s||0}}</p>
                        </div>
                    </div>
                    <div class="space-info">
                        <div class="tit">场地介绍</div>
                        <p>{{form3.content||''}}</p>
                        <div class="img-box" v-if="rulesForm.fileList[0]">
                            <img :src="rulesForm.fileList[0]|handleImg" alt="">
                        </div>
                        <div class="tit">场地相册</div>
                        <div class="anli d_flex j_b flex_wrap">

                            <div class="an-img" v-for="(item,i) in rulesForm.fileList1" :key="i">
                                <div class="img-box" v-if="item.path"><img :src="item.path|handleImg" alt=""></div>
                            </div>
                        </div>
                        <div class="tit">场地顾问信息</div>
                        <p style="text-align: left;display: flex;justify-content: space-between"><span>姓名：{{form3.contact_name}}</span><span>职位：{{form3.contact_position}}</span></p>
                        <p style="text-align: left;display: flex;justify-content: space-between"><span>微信号：{{form3.contact_wx}}</span></p>
                        <p style="text-align: left;display: flex;justify-content: space-between"><span>电话：{{form3.contact_phone}}</span></p>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="infoPop = false">取 消</el-button>
                <el-button type="primary" @click="infoPop = false">确 定</el-button>
              </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import BmView from 'vue-baidu-map/components/map/MapView.vue'
    import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue'
    import {spacecateList,saveSite} from '../../api/site'
    import {searchCity} from '../../api/city'
    import { mapState } from 'vuex';
    export default {
        name: "add-site",
        components: {
            BaiduMap,
            BmView,
            BmLocalSearch
        },
        data(){
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                }
                setTimeout(() => {
                    if (!/^[1][0-9]{10}$/.test(value)) {
                        callback(new Error('请输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 500);
            };
            return{
                site_page:1,
                token:'',
                infoPop:false,
                imgBox:'',
                currentStep:0,
                address:'',
                spaceList:[],
                subList:[],
                cityList:[],
                areList:[],
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                city: '',
                province: '',
                district: '',
                addressKeyword:'',
                selfKey: 'AkfcPW05jWhN7BbQkX7kpH6dfMdzLuME',
                point: { lng: '',lat: '' },
                location: {
                    lng: 116.404,
                    lat: 39.915
                },
                zoom: 12.8,
                addressObj:{
                    city:'',
                    area:'',
                    address:''
                },
                form1:{
                    space_name: '',
                    cate_id:'',
                    sub_cate_id:'',
                    subType:'',
                    size:'',
                    size_length:'',
                    size_width:'',
                    size_height:'',
                    area:'',
                    price:'',
                    floor_price:'',
                    lease_commencement_date:'',
                    use_car:true,
                    date1:'8:30',
                    date2:'17:30'
                },
                form2:{
                    city_id:'',
                    area_id:'',
                    address:'',
                    lng:'',
                    lat:'',
                },
                form3:{
                    contact_name:'',
                    contact_phone:'',
                    contact_wx:'',
                    contact_position:'',
                    content:'',
                },
                rulesForm: {
                    fileList:[],
                    fileList1:[],
                    fileList2:[],
                },
                rules1:{
                    space_name: [
                        { required: true, message: '请输入场地名称', trigger: 'blur' }
                    ],
                    cate_id:[
                        { required: true, message: '请选择场地类型', trigger: 'blur' }
                    ],
                    area:[
                        { required: true, message: '请输入场地面积', trigger: 'blur' }
                    ],
                    size_length:[
                        { required: true, message: '请输入场地尺寸', trigger: 'blur' }
                    ],
                    size_width:[
                        { required: true, message: '请输入场地尺寸', trigger: 'blur' }
                    ],
                    price:[
                        { required: true, message: '请输入平台价格', trigger: 'blur' }
                    ],
                    floor_price:[
                        { required: true, message: '请输入场地底价', trigger: 'blur' }
                    ],
                    date1:[
                        { required: true, message: '请选择营业时间', trigger: 'blur' }
                    ],
                },
                rules2:{
                    city_id:[
                        { required: true, message: '请选择城市', trigger: 'blur' }
                    ],
                    address:[
                        { required: true, message: '请输入详细地址', trigger: 'blur' }
                    ],
                    lng:[
                        { required: true, message: '请在地图上点击确认详细位置', trigger: 'blur' }
                    ],
                },
                rules3:{
                    contact_name:[
                        { required: true, message: '请输入场地管理员姓名', trigger: 'blur' }
                    ],
                    contact_phone:[
                        { required: true, message: '请输入场地管理员电话', trigger: 'blur' },
                        { validator: checkPhone, trigger: 'blur' }
                    ],
                    contact_wx:[
                        { required: true, message: '请输入场地管理员微信', trigger: 'blur' }
                    ],
                    contact_position:[
                        { required: true, message: '请输入场地管理员职务', trigger: 'blur' }
                    ],
                    content:[
                        { required: true, message: '请输入场地描述', trigger: 'blur' }
                    ]
                },
                rules4:{
                    fileList:[
                        { required: true, message: '请选择场地介绍图', trigger: 'blur' }
                    ],
                    fileList1:[
                        { required: true, message: '请选择场地现场图', trigger: 'blur' }
                    ],
                    fileList2:[
                        { required: true, message: '请选择场地现场图', trigger: 'blur' }
                    ],
                },
                edit:0,
                title:'新增场地',
                siteData:'',
            }
        },
        computed:{
            ...mapState(['baseUrl','cityArr'])
        },
        mounted(){
            this.edit=this.$route.query.type||0;
            this.site_page=this.$route.query.page||1;
            if(this.edit==1){
                this.title="修改场地";
                let site_data=JSON.parse(localStorage.getItem('update_site'));
                console.log(site_data);
                console.log(site_data.business_time.split('-'));
                this.siteData=site_data;
                this.form1={
                    space_name: site_data.space_name,
                    cate_id:[site_data.big_cate_id,site_data.space_cate_id],
                    sub_cate_id:site_data.cate_id,
                    subType:site_data.space_name,
                    size_length:site_data.size_length,
                    size_width:site_data.size_width,
                    size_height:site_data.size_height,
                    area:site_data.area,
                    price:site_data.price,
                    price_s:site_data.price_s,
                    floor_price_s:site_data.floor_price_s,
                    floor_price:site_data.floor_price,
                    lease_commencement_date:site_data.lease_commencement_date,
                    use_car:site_data.use_car?true:false,
                    date1:site_data.business_time.split('-')[0],
                    date2:site_data.business_time.split('-')[1]
                };
                this.form2={
                    city_id:[site_data.big_city_id,site_data.city_id],
                    area_id:site_data.city_id,
                    address:site_data.address,
                    lng:site_data.lng,
                    lat:site_data.lat,
                };
                this.form3={
                    contact_name:site_data.contact_name,
                    contact_phone:site_data.contact_phone,
                    contact_wx:site_data.contact_wx,
                    contact_position:site_data.contact_position,
                    content:site_data.address_res,
                };
                this.rulesForm={
                    fileList:site_data.cover?[site_data.cover]:[],
                    fileList2:site_data.plan?[site_data.plan]:[],
                };
                if(site_data.photo.length>0){
                    this.rulesForm.fileList1=site_data.photo.map(val=>{
                        val.uid=val.id;
                        val.url=this.baseUrl+val.path;
                        return val;
                    });
                }
                console.log( this.rulesForm)
            }
           this.getSiteList();
        },

        methods:{
            //选择类型
            selectType(e){
                console.log(e);
            },
            getLocationPoint(e) {
                console.log(e);
                this.form2.lng = e.point.lng;
                this.form2.lat = e.point.lat;
                /* 创建地址解析器的实例 */
                let geoCoder = new BMap.Geocoder();
                /* 获取位置对应的坐标 */
                geoCoder.getPoint(this.addressKeyword, point => {
                    this.selectedLng = point.lng;
                    this.selectedLat = point.lat;
                });
                /* 利用坐标获取地址的详细信息 */
                geoCoder.getLocation(e.point, res=>{
                    console.log(res);
                    this.form2.address=res.address;
                })
            },
            backPage(){
                this.$router.push({path: '/site/site',query:{page:this.site_page}});
                // this.$router.go(-1);
            },
            handlePicPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file) {
                this.rulesForm.fileList.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.rulesForm.fileList.splice(index,1)
                    }
                })
            },
            previewImg(file){
                if(file.indexOf('http')!=-1){
                    this.dialogImageUrl = file;
                }else{
                    this.dialogImageUrl = this.baseUrl+file;
                }
                this.dialogVisible = true;
            },
            deleteImg(i,j){
              if(i==1){
                  this.rulesForm.fileList.splice(j,1);
              }else if(i==2){
                  this.rulesForm.fileList2.splice(j,1);
              }
            },
            handlePicPreview1(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove1(file, fileList) {
                this.rulesForm.fileList1.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.rulesForm.fileList1.splice(index,1)
                    }
                });
                console.log(this.rulesForm.fileList1);
            },
            handlePicPreview2(file){
                console.log(file);
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove2(file, fileList) {
                this.rulesForm.fileList2.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.rulesForm.fileList2.splice(index,1)
                    }
                })
            },
            otherSectionFile(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'space');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                   if(res.data.code==1){
                       this.rulesForm.fileList.push(res.data.data.path);
                       console.log( this.rulesForm.fileList);
                   }
                })
            },
            otherSectionFile1(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'space');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                };
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        let obj={
                            path:res.data.data.path,
                            url:baseURL+res.data.data.path
                        };
                        this.rulesForm.fileList1.push(obj);
                    }
                })
            },
            otherSectionFile2(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'space');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        this.rulesForm.fileList2.push(res.data.data.path);
                    }
                })
            },
            getAddress(e){
                this.addressObj.address=this.form2.address;
                this.setSearchAddress();
            },
            setSearchAddress(){
                this.addressKeyword=this.addressObj.city+this.addressObj.area+this.addressObj.address;
            },
            preStep(){
                if(this.currentStep>0){
                    this.currentStep--
                }
            },
            changeStep(i){
                console.log(i);

                if(this.currentStep==0){
                    this.$refs['form1'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            this.currentStep=i;
                        }
                    });

                }
                if(this.currentStep==1){
                    this.$refs['form2'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            this.currentStep=i;
                        }
                    });
                }
                if(this.currentStep==2){
                    this.$refs['form3'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            this.currentStep=i;
                        }
                    });
                }
            },
            nextStep(){
                console.log(this.form1);
                if(this.currentStep==0){
                    this.addressKeyword=this.form2.address;
                    this.$refs['form1'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            if(this.currentStep<3){
                                this.currentStep++
                            }
                        }
                    });
                    return;
                }
                if(this.currentStep==1){
                    this.$refs['form2'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            if(this.currentStep<3){
                                this.currentStep++
                            }
                        }
                    });
                    return;
                }
                if(this.currentStep==2){
                    this.$refs['form3'].validate((valid) => {
                        if (!valid) {
                            return;
                        }else{
                            if(this.currentStep<3){
                                this.currentStep++
                            }
                        }
                    });
                }

            },
            submitForm(){
                console.log(this.rulesForm);
                let arr=this.rulesForm.fileList1.map(val=>{
                    return val.path;
                });
                let data={
                    space_name:this.form1.space_name,
                    space_cate_id:this.form1.cate_id[1]?this.form1.cate_id[1]:this.form1.cate_id[0],
                    city_id:this.form2.city_id[1],
                    cover:this.rulesForm.fileList[0],
                    plan:this.rulesForm.fileList2[0],
                    size_height:this.form1.size_height,
                    size_length:this.form1.size_length,
                    size_width:this.form1.size_width,
                    size:this.form1.size,
                    area:this.form1.area,
                    business_time:this.form1.date1+'-'+this.form1.date2,
                    price:this.form1.price,
                    price_s:this.form1.price_s,
                    floor_price:this.form1.floor_price,
                    floor_price_s:this.form1.floor_price_s,
                    lease_commencement_date:this.form1.lease_commencement_date,
                    use_car:this.form1.use_car,
                    address:this.form2.address,
                    address_res:this.form3.content,
                    lng_lat:this.form2.lng+','+this.form2.lat,
                    contact_name:this.form3.contact_name,
                    contact_phone:this.form3.contact_phone,
                    contact_position:this.form3.contact_position,
                    contact_wx:this.form3.contact_wx,
                    new_photos:arr.join(','),
                };
                let str='创建成功';
               if(this.edit==1){
                   data.space_id=this.siteData.space_id;
                   str='修改成功'
               }
                saveSite(data).then(res=>{
                    if(res.code==1){
                        this.$message.success(str);
                        if(this.edit==1){
                            this.$router.go(-1);
                        }else{
                            this.$router.push({path: '/site/site'});
                        }
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },

            getSiteList(){
                spacecateList().then(res=>{
                    if(res.code==1){
                        this.spaceList=res.data
                    }
                })
            },
            getSubList(){
                spacecateList({
                    cate_id:this.form1.cate_id
                }).then(res=>{
                    if(res.code==1){
                        this.subList=res.data
                    }
                })
            },
            changeSpace(){
                this.form1.space_cate_id='';
                this.getSubList();
            },
            openPreview(){
                this.infoPop=true;
            }
        }
    }
</script>

<style lang="scss" scoped>
.add-top{
    padding: 20px;
}
    .add-content{
        padding: 20px 20px 120px 20px;
        .content{
            background-color: #fff;
            padding: 20px;
            box-shadow: 0 4px 4px 0 #e1e5eb;
            position: relative;
            min-height: 450px;
            .page-title{
                text-align: left;
                font-size: 24px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #30323f;
                padding: 10px 0 28px 10px;
                background: #fff;
            }
            .left{
                position: fixed;
                min-height: 400px;
                width: 130px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                border-right: 1px solid #eaeaea;
                background-color: #fff;
                z-index: 9;
                .item{
                    width: 120px;
                    height: 40px;
                    margin-bottom: 30px;
                    align-items: center;
                    cursor: pointer;
                    position: relative;
                    &:hover{
                        background-color: #F7F9FC;
                    }

                    &:nth-child(-n+3){
                        &::after{
                            position: absolute;
                            bottom: -25px;
                            content:'';
                            left: 12px;
                            width: 1px;
                            height: 20px;
                            border-left: 1px dotted #bdbdbd;
                            display: inline-block;
                        }
                    }
                    .step{
                        width: 24px;
                        height: 24px;
                        margin-right: 10px;
                        border-radius: 50%;
                        background-color: #f7f9fc;
                        text-align: center;
                        line-height: 24px;
                        font-size: 15px;
                        color: #c0c4cc;
                    }
                    &.active{
                        .step{
                            background: #2196f3;
                            color: #ffffff;
                        }
                    }
                    &.writting{
                        .step{
                            color: #4890f7;
                            background: rgba(72,144,247,.1);
                        }
                    }
                }
            }
            .right{
                padding-left:  200px;
                min-height: 450px;
            }
        }
    }
    .bottom-box{
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        padding: 30px 0 30px 250px;
        width: 100%;
        box-shadow: 0 -2px 4px 0 #e1e5eb;
    }
    .preview-box{
        width: 325px;
        height: 500px;
        padding: 0 20px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        overflow-y: auto ;
        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);
        }
        .tit{
            margin-top: 10px;
        }
        .img-box{
            width: 100%;
            height: 250px;
            background-color: #aaa;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .space-msg{
            text-align: left;
        }
        .space-info{
            margin-top: 10px;
            .tit{
                font-size: 15px;
                font-weight: bold;
                text-align: left;
                margin-bottom: 10px;
                color: #000000;
            }
            .an-img{
                width: 48%;
                .img-box{
                    width: 100%;
                    height: 80px;
                    background-color: #aaaaaa;
                    margin-bottom: 10px;
                    img{
                        width: 100%;
                        height: 80px;
                    }
                }
            }
        }
    }

    .map-box{
        width: 800px;
        height:500px;
        position: relative;
    }
    #baidu-map{
        width: 800px;
        height: 400px;
        position: absolute;
    }
    .upload-img-box{
        width: 100%;
        .img{
            width: 200px;
            height: 150px;
            border-radius: 4px;
            margin-right: 10px;
            position: relative;
            i{
                position: absolute;
                top: -5px;
                font-size: 24px;
                color: #f00;
            }
            .el-icon-error{
                right: -5px;
            }
            img{
                width: 200px;
                height: 150px;
                border-radius: 4px;
            }
        }
    }


</style>
<style>
    /deep/ div.BMap_cpyCtrl.BMap_noprint.anchorBL {
        display: none;
    }
   /deep/ div.anchorBL {
        display: none;
    }
    /deep/ .BMap_mask {
        cursor: default;
    }
    .avatar-uploader{
        display: flex;
        flex-wrap: wrap;
    }
    .avatar-uploader .el-upload--picture-card{
        width: 200px;
        height: 150px;
    }
    .avatar-uploader .el-upload-list--picture-card .el-upload-list__item{
        width: 200px;
        height: 150px;
    }
    .avatar-uploader .el-upload{
        width: 200px;
        height: 150px;
        line-height: 150px;
    }
    .avatar-uploader .el-upload-list--picture-card{
        display: flex;
    }
    .el-date-editor .el-range-separator{
        width: 7%;
    }
    .avatar-uploader .el-upload-list--picture-card{
        flex-wrap: wrap;
    }
</style>
